/* ESTEN: release the page after the mobile menu closes.
   The theme only finishes closing the drawer when its closing animation fires an event; on some phones
   (for example with Reduce Motion on) that event never comes, the drawer stays [open] and the page
   cannot scroll. Here: once the drawer loses .menu-open, finish the close ourselves shortly after. */
(function () {
  'use strict';
  function unlock() {
    var els = [document.documentElement, document.body];
    els.forEach(function (el) {
      if (!el) return;
      if (el.style.overflow === 'hidden') el.style.overflow = '';
      if (el.style.overflowY === 'hidden') el.style.overflowY = '';
      if (el.style.position === 'fixed') { el.style.position = ''; el.style.top = ''; el.style.width = ''; }
      el.style.touchAction = '';
      ['overflow-hidden', 'scroll-lock', 'no-scroll'].forEach(function (c) { el.classList.remove(c); });
    });
  }
  function finish(details) {
    if (details.classList.contains('menu-open')) return;
    if (details.hasAttribute('open')) {
      details.removeAttribute('open');
      var s = details.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false');
    }
    var drawer = details.closest('header-drawer');
    if (drawer) drawer.querySelectorAll('details[open]').forEach(function (d) { if (!d.classList.contains('menu-open') && !d.closest('accordion-custom')) d.removeAttribute('open'); });
    unlock();
  }
  function watch(details) {
    if (details.dataset.estenWatch) return; details.dataset.estenWatch = '1';
    var wasOpen = details.classList.contains('menu-open');
    new MutationObserver(function () {
      var isOpen = details.classList.contains('menu-open');
      if (wasOpen && !isOpen) setTimeout(function () { finish(details); }, 450);
      wasOpen = isOpen;
    }).observe(details, { attributes: true, attributeFilter: ['class'] });
  }
  function boot() {
    document.querySelectorAll('header-drawer details').forEach(watch);
    // links inside the drawer that stay on the same page (e.g. /#esten-story) must also close it
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('header-drawer a[href]');
      if (!a) return;
      var hd = a.closest('header-drawer');
      if (hd && typeof hd.close === 'function') { try { hd.close(); } catch (err) {} }
      document.querySelectorAll('header-drawer details').forEach(function (d) { setTimeout(function () { d.classList.remove('menu-open'); finish(d); }, 30); });
    });
    // last resort: if no drawer is open but the page is still locked, unlock on the first touch
    document.addEventListener('touchstart', function () {
      if (!document.querySelector('header-drawer details.menu-open')) unlock();
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
